export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8024.dcc30f02.jpg";